<script setup lang="ts">
import {
  useI18n,
} from 'vue-i18n'

import {
  NuxtLoadingIndicator,
  NuxtLayout,
  NuxtPage,
} from '#components'
import { useHead } from '#imports'
import { browserStoreProvide } from '@/stores/browserStore'
import { domSizeStoreProvide } from '@/stores/domSizeStore'

const { t, locale } = useI18n()
useHead({
  title: t('common.head_title'),
  meta: [{ name: 'og:title', content: t('common.head_title') }],
  htmlAttrs: {
    lang: locale,
  },
})

/**
 * Providers
 */
browserStoreProvide()
domSizeStoreProvide('layoutHeader')
domSizeStoreProvide('layoutFooter')
domSizeStoreProvide('layoutAsideRight')
</script>

<template>
  <v-app
    id="app"
    :class="{ 'font-jp-only': locale === 'ja' } "
  >
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#51b3f9 0%,#d8f4ff 50%,#0063ff 100%)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </v-app>
</template>
